import { BannerBadgeProps } from './BannerBadge';

type BadgeType = BannerBadgeProps['badge'];

export const getPriceText = (badge?: BadgeType, saveAmount?: number, wasPrice?: number) => {
  if (!badge || !saveAmount || !wasPrice) {
    return undefined;
  }
  const percentageOff = Math.floor((saveAmount / wasPrice) * 100);
  if (saveAmount <= 0 || percentageOff <= 0) {
    return undefined;
  }

  switch (badge) {
    case '$ off':
      return Number.isInteger(saveAmount) ? `$${saveAmount}` : `$${saveAmount.toFixed(2)}`;
    case '% off':
      return `${percentageOff}%`;
    default:
      return undefined;
  }
};
export const getSubText = (badge?: BadgeType) => {
  switch (badge) {
    case '$ off':
      return 'OFF^';
    case '% off':
      return 'OFF^';

    default:
      return undefined;
  }
};

export const getHotDealHalfPriceText = (badge?: BadgeType) => {
  switch (badge) {
    case 'Hot price!':
      return 'HOT PRICE!';
    case 'Hot deal!':
      return 'HOT DEAL!';
    case '1/2 price':
      return '1/2 PRICE!';
    default:
      return undefined;
  }
};
